<template>
  <div>
    <rebateapply
      v-if="roleperson.role == 1 && roleperson.refundState == 0"
      :details="details"
      :refundType="refundType"
      @show1="showflow"
    ></rebateapply>
    <rebateappling
      v-if="
        (roleperson.role == 2 && roleperson.refundState == 1) ||
        (roleperson.role == 1 && roleperson.refundState == 1)
      "
      :afterSaleId="afterSaleId"
      :refundType="refundType"
      @show2="showflow2"
      @show3="showflow3"
      @show4="showflow4"
    ></rebateappling>
    <rebateed
      v-if="
        roleperson.refundState == 2 ||
        roleperson.refundState == 3 ||
        roleperson.refundState == 4
      "
      :afterSaleId="afterSaleId"
      :refundType="refundType"
    ></rebateed>
  </div>
</template>

<script>
import rebateapply from './components/rebateapply'
import rebateappling from './components/rebateappling'
import rebateed from './components/rebateed'
import { getparticulars } from '@/api/refund/index'
import { disfreightInfo } from '@/api/freight/index'
export default {
  name: 'salesreturn',
  components: {
    rebateapply,
    rebateappling,
    rebateed
  },
  data() {
    return {
      roleperson: {},
      details: '',
      afterSaleId: '',
      refundType: ''
    }
  },
  created() {
    this.orderdetails()
    this.reimbursemoney()
  },
  methods: {
    showflow(res) {
      console.log(res);
      this.afterSaleId = res.data
      this.refundType = res.refundType
      this.roleperson.refundState = 1
      this.roleperson.role = 1
      console.log(this.afterSaleId)
    },
    // 同意退款
    showflow2(res) {
      // this.finish = res
      this.roleperson.refundState = 4
      // console.log(this.finish)
    },
    // 拒绝退款
    showflow3(res) {
      this.roleperson.refundState = 2
      // this.finish = res
      // console.log(this.finish)
    },
    // 撤销申请
    showflow4(res) {
      this.roleperson.refundState = 3
      this.refundType = res.refundType
      // this.afterSaleId = res.data
      console.log(res);
      // this.finish = res
      // console.log(this.finish)
    },
    // 正常流程
    async orderdetails() {
      this.details = this.$route.query.details
      console.log(this.details)
      // const res = await getparticulars('1481149227587796994')
      if (this.details) {
        const res = await getparticulars({ orderId: this.details, type: 2 })
        console.log(res)
        if (res.status) {
          this.roleperson = res.data
          this.afterSaleId = res.data.afterSaleId
        }
      } else {
        return false
      }
    },
    // 退款订单
    async reimbursemoney() {
      this.drawback = this.$route.query.drawback
      this.refundType = this.$route.query.refundType
      console.log(this.$route.query.refundType)
      if (this.drawback) {
        const res = await disfreightInfo(this.drawback + '/' + this.refundType)
        console.log(res)
        if (res.status) {
          this.roleperson = res.data
          this.afterSaleId = res.data.afterSaleId
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped></style>
